export default {
  pt: {
    'tickets.ticketsPage.approved': 'Ticket aprovado. Cargas geradas.',
    'tickets.ticketsPage.statusUpdated': 'Status atualizado.',
    'tickets.ticketsPage.allStatuses': 'Todos os status',
    'tickets.ticketsPage.number': 'Número',
    'tickets.ticketsPage.customer': 'Cliente',
    'tickets.ticketsPage.contract': 'Contrato',
    'tickets.ticketsPage.loads': 'Cargas',
    'tickets.ticketsPage.priority': 'Prioridade',
    'tickets.ticketsPage.date': 'Data',
    'tickets.ticketsPage.title': 'Tickets',
    'tickets.ticketsPage.eyebrow': 'Operação',
    'tickets.ticketsPage.subtitle': 'Pedidos de embarque (cadenciamento). Dê tratativa e mova pelo fluxo.',
    'tickets.ticketsPage.newTicket': 'Novo ticket',
    'tickets.ticketsPage.list': 'Lista',
    'tickets.ticketsPage.filterStatus': 'Filtrar por status',
    'tickets.ticketsPage.searchStatus': 'Buscar status…',
    'tickets.ticketsPage.loadFailed': 'Não foi possível carregar.',
    'tickets.ticketsPage.approveTitle': 'Aprovar ticket?',
    'tickets.ticketsPage.approveMessage': 'Aprovar gera as cargas automaticamente com a cadência calculada. Deseja continuar?',
    'tickets.ticketsPage.approveAndGenerate': 'Aprovar e gerar cargas',
    'tickets.ticketsPage.kanban': 'Kanban',
    'tickets.ticketsPage.status.draft': 'Rascunho',
    'tickets.ticketsPage.status.submitted': 'Enviada',
    'tickets.ticketsPage.status.under_review': 'Em análise',
    'tickets.ticketsPage.status.approved': 'Aprovada',
    'tickets.ticketsPage.status.in_progress': 'Em execução',
    'tickets.ticketsPage.status.completed': 'Concluída',
    'tickets.ticketsPage.status.cancelled': 'Cancelada',
    'tickets.ticketsPage.priorityValue.low': 'Baixa',
    'tickets.ticketsPage.priorityValue.normal': 'Normal',
    'tickets.ticketsPage.priorityValue.high': 'Alta',
    'tickets.ticketsPage.priorityValue.urgent': 'Urgente',
  },
  en: {
    'tickets.ticketsPage.approved': 'Ticket approved. Loads generated.',
    'tickets.ticketsPage.statusUpdated': 'Status updated.',
    'tickets.ticketsPage.allStatuses': 'All statuses',
    'tickets.ticketsPage.number': 'Number',
    'tickets.ticketsPage.customer': 'Customer',
    'tickets.ticketsPage.contract': 'Contract',
    'tickets.ticketsPage.loads': 'Loads',
    'tickets.ticketsPage.priority': 'Priority',
    'tickets.ticketsPage.date': 'Date',
    'tickets.ticketsPage.title': 'Tickets',
    'tickets.ticketsPage.eyebrow': 'Operations',
    'tickets.ticketsPage.subtitle': 'Shipping requests (scheduling). Process them and move them through the workflow.',
    'tickets.ticketsPage.newTicket': 'New ticket',
    'tickets.ticketsPage.list': 'List',
    'tickets.ticketsPage.filterStatus': 'Filter by status',
    'tickets.ticketsPage.searchStatus': 'Search status…',
    'tickets.ticketsPage.loadFailed': 'Could not load.',
    'tickets.ticketsPage.approveTitle': 'Approve ticket?',
    'tickets.ticketsPage.approveMessage': 'Approval automatically generates loads using the calculated schedule. Continue?',
    'tickets.ticketsPage.approveAndGenerate': 'Approve and generate loads',
    'tickets.ticketsPage.kanban': 'Kanban',
    'tickets.ticketsPage.status.draft': 'Draft',
    'tickets.ticketsPage.status.submitted': 'Submitted',
    'tickets.ticketsPage.status.under_review': 'Under review',
    'tickets.ticketsPage.status.approved': 'Approved',
    'tickets.ticketsPage.status.in_progress': 'In progress',
    'tickets.ticketsPage.status.completed': 'Completed',
    'tickets.ticketsPage.status.cancelled': 'Cancelled',
    'tickets.ticketsPage.priorityValue.low': 'Low',
    'tickets.ticketsPage.priorityValue.normal': 'Normal',
    'tickets.ticketsPage.priorityValue.high': 'High',
    'tickets.ticketsPage.priorityValue.urgent': 'Urgent',
  },
  es: {
    'tickets.ticketsPage.approved': 'Ticket aprobado. Cargas generadas.',
    'tickets.ticketsPage.statusUpdated': 'Estado actualizado.',
    'tickets.ticketsPage.allStatuses': 'Todos los estados',
    'tickets.ticketsPage.number': 'Número',
    'tickets.ticketsPage.customer': 'Cliente',
    'tickets.ticketsPage.contract': 'Contrato',
    'tickets.ticketsPage.loads': 'Cargas',
    'tickets.ticketsPage.priority': 'Prioridad',
    'tickets.ticketsPage.date': 'Fecha',
    'tickets.ticketsPage.title': 'Tickets',
    'tickets.ticketsPage.eyebrow': 'Operación',
    'tickets.ticketsPage.subtitle': 'Solicitudes de embarque (programación). Gestiónelas y muévalas por el flujo.',
    'tickets.ticketsPage.newTicket': 'Nuevo ticket',
    'tickets.ticketsPage.list': 'Lista',
    'tickets.ticketsPage.filterStatus': 'Filtrar por estado',
    'tickets.ticketsPage.searchStatus': 'Buscar estado…',
    'tickets.ticketsPage.loadFailed': 'No se pudo cargar.',
    'tickets.ticketsPage.approveTitle': '¿Aprobar ticket?',
    'tickets.ticketsPage.approveMessage': 'La aprobación genera automáticamente las cargas con la programación calculada. ¿Desea continuar?',
    'tickets.ticketsPage.approveAndGenerate': 'Aprobar y generar cargas',
    'tickets.ticketsPage.kanban': 'Kanban',
    'tickets.ticketsPage.status.draft': 'Borrador',
    'tickets.ticketsPage.status.submitted': 'Enviada',
    'tickets.ticketsPage.status.under_review': 'En análisis',
    'tickets.ticketsPage.status.approved': 'Aprobada',
    'tickets.ticketsPage.status.in_progress': 'En ejecución',
    'tickets.ticketsPage.status.completed': 'Completada',
    'tickets.ticketsPage.status.cancelled': 'Cancelada',
    'tickets.ticketsPage.priorityValue.low': 'Baja',
    'tickets.ticketsPage.priorityValue.normal': 'Normal',
    'tickets.ticketsPage.priorityValue.high': 'Alta',
    'tickets.ticketsPage.priorityValue.urgent': 'Urgente',
  },
}
